import { useState } from "react";

import api from "@helpers/api";

import {Input} from "@fragments";

import { HomeRounded } from "@mui/icons-material";

import Section, { SectionRow } from "../Section";

export default function BankAddress({ REF_values }) {
    const [loading, setLoading] = useState(false);

    async function handleCepChange(cep) {
        console.log(cep);
        if (`${cep}`.length !== 8) return;

        setLoading(true);

        try {
            const { data } = await api.get(`https://brasilapi.com.br/api/cep/v1/${cep}`);

            REF_values.current.address.street = data.street;
            REF_values.current.address.neighborhood = data.neighborhood;
            REF_values.current.address.city = data.city;
            REF_values.current.address.state = data.state;
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    return (
        <Section
            key={loading}
            icon={<HomeRounded />}
            title="Endereço"
            description="Informe o endereço do titular da conta"
        >
            <SectionRow>
                <Input.Integer
                    max={8}
                    label="CEP"
                    autoFocus
                    placeholder="00000-000"
                    value={REF_values.current.address.zipcode}
                    onInput={(value) => {
                        REF_values.current.address.zipcode = value;
                        handleCepChange(value);
                    }}
                    loading={loading}
                />
                <Input.Text
                    label="Logradouro"
                    placeholder="Rua, Avenida, etc"
                    value={REF_values.current.address.street}
                    onInput={(value) => REF_values.current.address.street = value}
                />
            </SectionRow>

            <SectionRow>
                <Input.Text
                    label="Número"
                    placeholder="000"
                    value={REF_values.current.address.number}
                    onInput={(value) => REF_values.current.address.number = value}
                />
                <Input.Text
                    label="Complemento"
                    placeholder="Apto, Bloco, etc"
                    value={REF_values.current.address.complement}
                    onInput={(value) => REF_values.current.address.complement = value}
                />
            </SectionRow>

            <SectionRow>
                <Input.Text
                    label="Bairro"
                    placeholder="Bairro"
                    value={REF_values.current.address.neighborhood}
                    onInput={(value) => REF_values.current.address.neighborhood = value}
                />
                <Input.Text
                    label="Cidade"
                    placeholder="Cidade"
                    value={REF_values.current.address.city}
                    onInput={(value) => REF_values.current.address.city = value}
                />
            </SectionRow>

            <SectionRow>
                <Input.Text
                    label="Estado"
                    placeholder="UF"
                    value={REF_values.current.address.state}
                    onInput={(value) => REF_values.current.address.state = value}
                />
            </SectionRow>
        </Section>
    );
}